<template>
  <div
    class="wh-text-list-ctnr"
    v-if="lclTools.getWarehouseShowList(detail,this.$i18n.locale).length > 0"
  >
    <div class="item-label">
      {{ $t("message.lclAdd.jiehuocangku") }}:
    </div>
    <div class="item-value">
      <div
        class="wh-item"
        v-for="(item, index) in lclTools.getWarehouseShowList(detail,this.$i18n.locale)"
        :key="index"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import * as lclTools from "@/pages/lclFreightList/lclTools.js";
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  components: {},
  data() {
    return { lclTools };
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
// font-size: 13px;
// font-weight: bold;
// color: #323239;
.wh-text-list-ctnr {
  display: flex;
  align-items: baseline;

  .item-label {
    flex: 0 0 auto;
  }
  .item-value {
    margin-left: 2px;
    .wh-item {
      word-break: break-word;
      overflow-wrap: break-word;
      word-wrap: break-word;
      white-space: normal;
    }
  }
}
</style>
